import { apiDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Divider,
    Dropdown,
    Form,
    FormGroup,
    Input,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const CommunicationChannelForm = ({ communication }) => {
    const { employee } = usePage().props;
    const { data, setData, post, errors, processing, reset } = useForm({
        scheduled_at: apiDate(new Date()),
    });
    const { confirm, setLoading } = useConfirmationStore();

    const handleSubmit = () =>
        confirm({
            title: 'Communicatie inplannen?',
            description:
                'Weet je zeker dat je dit communicatiemoment wilt inplannen?',
            confirmLabel: 'Inplannen',
            variant: 'primary',
            onConfirm: close => {
                setLoading(true);

                post(
                    `/customers/${employee.customer_id}/employees/${employee.id}/communications/${communication.id}/channels`,
                    {
                        reset: [
                            'employee',
                            'communicable_subjects',
                            'navigation',
                        ],
                        preserveScroll: true,
                        preserveState: true,
                        onSuccess: () => reset(),
                        onFinish: close,
                    }
                );
            },
        });

    return (
        <>
            <Divider content='Communicatie inplannen' className='my-8' />

            <Form onSubmit={handleSubmit}>
                <FormGroup inline equal>
                    <Dropdown
                        label='Kanaal'
                        value={data?.type || ''}
                        required
                        options={[
                            {
                                id: 'email',
                                name: 'E-mail',
                            },
                            {
                                id: 'phone',
                                name: 'Telefoon',
                            },
                            {
                                id: 'customer',
                                name: 'Klant',
                            },
                            {
                                id: 'whatsapp',
                                name: 'WhatsApp',
                            },
                        ]}
                        onChange={value => setData('type', value)}
                        error={errors?.type}
                    />
                    <Input
                        label='Gepland op'
                        required
                        type='date'
                        value={data?.scheduled_at || ''}
                        onChange={event =>
                            setData('scheduled_at', event.target.value)
                        }
                        error={errors?.scheduled_at}
                    />
                </FormGroup>
                <div className='mt-4 flex items-center justify-end'>
                    <Button
                        variant='primary'
                        type='submit'
                        loading={processing}
                    >
                        Inplannen
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default CommunicationChannelForm;
